import React, { Component } from 'react';
import { connect } from "react-redux";

import axios from "axios";
import { VCIcon, DivisionIcon } from './Buttons/TypeIcons';
import ReactTooltip from 'react-tooltip';
import { constants } from '../../Helpers/Constants';

class GeneratedTypeIcons extends Component {
    constructor(props) {
        super(props);

        this.state = {
            shown: false,
            icons: [],
            tooltip_icons: [],
            width: 50
        };

        this.toggleHover = this.toggleHover.bind(this);
    }

    componentDidMount() {
        var icons = [];
        var tooltip_icons = [];
        var department_icons = {};
        var vc_icons = {};
        var width = (26) + (1*4) + 18;
        var customer = this.props.customer;
        var type = this.props.type;

        for (var i = 0; i < customer.sh_vmh_access.length; i++) {
            var icon;
            if (type === "Department") {
                if (! (customer.sh_vmh_access[i].stakeholder.SH_ID in department_icons)) {
                    department_icons[customer.sh_vmh_access[i].stakeholder.SH_ID] = true;
                    icon = DivisionIcon(customer.sh_vmh_access[i].stakeholder, undefined, undefined, undefined, true)

                    if (icons.length < 3) {
                        icons.push(icon)
                    } else {
                        tooltip_icons.push(icon)
                    }
                }
            } else if (type === "Centre") {
                
                if (! (customer.sh_vmh_access[i].vmh.VMH_ID in department_icons)) {
                    department_icons[customer.sh_vmh_access[i].vmh.VMH_ID] = true;
                    icon = VCIcon(customer.sh_vmh_access[i].vmh, undefined, undefined, undefined, true)

                    if (icons.length < 3) {
                        icons.push(icon)
                    } else {
                        tooltip_icons.push(icon)
                    }
                }
            }
        }

        if ('sh_requests' in customer) {
            for (var i = 0; i < customer.sh_requests.length; i++) {
                if (customer.sh_requests[i].Status === constants.user_request_status.requested) {
                    var icon;
                    if (type === "Department") {
                        if (! (customer.sh_requests[i].stakeholder.SH_ID in department_icons)) {
                            department_icons[customer.sh_requests[i].stakeholder.SH_ID] = true;
                            icon = DivisionIcon(customer.sh_requests[i].stakeholder, undefined, undefined, undefined, true)
        
                            if (icons.length < 3) {
                                icons.push(icon)
                            } else {
                                tooltip_icons.push(icon)
                            }
                        }
                    } else if (type === "Centre") {
                        
                        if (! (customer.sh_requests[i].vmh.VMH_ID in department_icons)) {
                            department_icons[customer.sh_requests[i].vmh.VMH_ID] = true;
                            icon = VCIcon(customer.sh_requests[i].vmh, undefined, undefined, undefined, true)
        
                            if (icons.length < 3) {
                                icons.push(icon)
                            } else {
                                tooltip_icons.push(icon)
                            }
                        }
                    }
                }
            }
        }

        if (tooltip_icons.length > 0) {
            width = (tooltip_icons.length * 26) + ((tooltip_icons.length - 1) * 4) + 24
        }

        this.setState({
            icons: icons,
            tooltip_icons: tooltip_icons,
            width: width
        })
    }

    toggleHover() {
        this.setState({
            shown: !this.state.shown
        })
    }

    render() {
        return (
            <div style={{display: 'inline-flex', alignItems: 'center'}}>
                {this.state.icons}
                {
                    this.state.tooltip_icons.length > 0 ?
                        <div className = "num-block" onMouseEnter={this.toggleHover} onMouseLeave={this.toggleHover}>
                            +{this.state.tooltip_icons.length}
                            {/* {
                                this.state.shown ? 
                                    <div className="multi-img-hover is-shown" style={{"width": this.state.width + "px"}} onMouseLeave={this.toggleHover}>
                                        {this.state.tooltip_icons}
                                    </div>
                                :
                                    null
                            } */}
                        </div>
                    :
                        null
                }
            </div>
        );
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession
})

export default connect(mapStateToProps)(GeneratedTypeIcons)